/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      companyId
      firstName
      lastName
      email
      phone
      userType {
        userType
      }
      isActive
      imageUrl
      emailSentOn
      emailVerifiedOn
      isVerified
      lastActiveOn
      updatedAt
      company {
        id
        name
        email
        phone
        address
        state
        city
        zip
        referralCode
        users {
          nextToken
        }
        meetings {
          nextToken
        }
        teams {
          nextToken
        }
        createdAt
        updatedAt
      }
      team {
        items {
          id
          teamUserUserId
          teamUserTeamId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyId
        firstName
        lastName
        email
        phone
        userType {
          userType
        }
        isActive
        imageUrl
        emailSentOn
        emailVerifiedOn
        isVerified
        lastActiveOn
        updatedAt
        company {
          id
          name
          email
          phone
          address
          state
          city
          zip
          referralCode
          createdAt
          updatedAt
        }
        team {
          nextToken
        }
        createdAt
      }
      nextToken
    }
  }
`;
export const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      name
      email
      phone
      address
      state
      city
      zip
      referralCode
      users {
        items {
          id
          companyId
          firstName
          lastName
          email
          phone
          isActive
          imageUrl
          emailSentOn
          emailVerifiedOn
          isVerified
          lastActiveOn
          updatedAt
          createdAt
        }
        nextToken
      }
      meetings {
        items {
          id
          companyId
          title
          date
          shortId
          teamId
          meta
          createdAt
          updatedAt
        }
        nextToken
      }
      teams {
        items {
          id
          companyId
          name
          color
          icon
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCompanys = /* GraphQL */ `
  query ListCompanys(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        email
        phone
        address
        state
        city
        zip
        referralCode
        users {
          nextToken
        }
        meetings {
          nextToken
        }
        teams {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTeamUser = /* GraphQL */ `
  query GetTeamUser($id: ID!) {
    getTeamUser(id: $id) {
      id
      teamUserUserId
      teamUserTeamId
      user {
        id
        companyId
        firstName
        lastName
        email
        phone
        userType {
          userType
        }
        isActive
        imageUrl
        emailSentOn
        emailVerifiedOn
        isVerified
        lastActiveOn
        updatedAt
        company {
          id
          name
          email
          phone
          address
          state
          city
          zip
          referralCode
          createdAt
          updatedAt
        }
        team {
          nextToken
        }
        createdAt
      }
      team {
        id
        companyId
        name
        color
        icon
        user {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listTeamUsers = /* GraphQL */ `
  query ListTeamUsers(
    $filter: ModelTeamUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeamUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        teamUserUserId
        teamUserTeamId
        user {
          id
          companyId
          firstName
          lastName
          email
          phone
          isActive
          imageUrl
          emailSentOn
          emailVerifiedOn
          isVerified
          lastActiveOn
          updatedAt
          createdAt
        }
        team {
          id
          companyId
          name
          color
          icon
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTeam = /* GraphQL */ `
  query GetTeam($id: ID!) {
    getTeam(id: $id) {
      id
      companyId
      name
      color
      icon
      user {
        items {
          id
          teamUserUserId
          teamUserTeamId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listTeams = /* GraphQL */ `
  query ListTeams(
    $filter: ModelTeamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyId
        name
        color
        icon
        user {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getMeeting = /* GraphQL */ `
  query GetMeeting($id: ID!) {
    getMeeting(id: $id) {
      id
      companyId
      meetingType {
        meetingType
      }
      title
      date
      shortId
      teamId
      meta
      createdAt
      updatedAt
    }
  }
`;
export const listMeetings = /* GraphQL */ `
  query ListMeetings(
    $filter: ModelMeetingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMeetings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyId
        meetingType {
          meetingType
        }
        title
        date
        shortId
        teamId
        meta
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAppLog = /* GraphQL */ `
  query GetAppLog($id: ID!) {
    getAppLog(id: $id) {
      id
      message
      level
      madeBy
      meta
      createdAt
      updatedAt
    }
  }
`;
export const listAppLogs = /* GraphQL */ `
  query ListAppLogs(
    $filter: ModelAppLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        message
        level
        madeBy
        meta
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserByCompany = /* GraphQL */ `
  query GetUserByCompany(
    $companyId: ID
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getUserByCompany(
      companyId: $companyId
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        firstName
        lastName
        email
        phone
        userType {
          userType
        }
        isActive
        imageUrl
        emailSentOn
        emailVerifiedOn
        isVerified
        lastActiveOn
        updatedAt
        company {
          id
          name
          email
          phone
          address
          state
          city
          zip
          referralCode
          createdAt
          updatedAt
        }
        team {
          items {
            teamUserTeamId
            teamUserUserId
            updatedAt
            team {
              color
              companyId
              createdAt
              id
              icon
              name
            }
          }
          nextToken
        }
        createdAt
      }
      nextToken
    }
  }
`;
export const getUserByEmail = /* GraphQL */ `
  query GetUserByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getUserByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        firstName
        lastName
        email
        phone
        userType {
          userType
        }
        isActive
        imageUrl
        emailSentOn
        emailVerifiedOn
        isVerified
        lastActiveOn
        updatedAt
        company {
          id
          name
          email
          phone
          address
          state
          city
          zip
          referralCode
          createdAt
          updatedAt
        }
        team {
          items {
            teamUserTeamId
            teamUserUserId
            updatedAt
            team {
              color
              companyId
              createdAt
              icon
              name
              id
            }
          }
        }
        createdAt
      }
      nextToken
    }
  }
`;
export const getCompanyByName = /* GraphQL */ `
  query GetCompanyByName(
    $name: String
    $sortDirection: ModelSortDirection
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCompanyByName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        email
        phone
        address
        state
        city
        zip
        referralCode
        users {
          nextToken
        }
        meetings {
          nextToken
        }
        teams {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTeamUserInfo = /* GraphQL */ `
  query GetTeamUserInfo(
    $teamUserTeamId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelTeamUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getTeamUserInfo(
      teamUserTeamId: $teamUserTeamId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teamUserUserId
        teamUserTeamId
        user {
          id
          companyId
          firstName
          lastName
          email
          phone
          isActive
          imageUrl
          emailSentOn
          emailVerifiedOn
          isVerified
          lastActiveOn
          updatedAt
          createdAt
        }
        team {
          id
          companyId
          name
          color
          icon
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserTeamInfo = /* GraphQL */ `
  query GetUserTeamInfo(
    $teamUserUserId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelTeamUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getUserTeamInfo(
      teamUserUserId: $teamUserUserId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teamUserUserId
        teamUserTeamId
        user {
          id
          companyId
          firstName
          lastName
          email
          phone
          isActive
          imageUrl
          emailSentOn
          emailVerifiedOn
          isVerified
          lastActiveOn
          updatedAt
          createdAt
        }
        team {
          id
          companyId
          name
          color
          icon
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTeamByCompany = /* GraphQL */ `
  query GetTeamByCompany(
    $companyId: ID
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTeamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getTeamByCompany(
      companyId: $companyId
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        name
        color
        icon
        user {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getMeetingByCompany = /* GraphQL */ `
  query GetMeetingByCompany(
    $companyId: ID
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMeetingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getMeetingByCompany(
      companyId: $companyId
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        meetingType {
          meetingType
        }
        title
        date
        shortId
        teamId
        meta
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getMeetingByTitle = /* GraphQL */ `
  query GetMeetingByTitle(
    $title: String
    $sortDirection: ModelSortDirection
    $filter: ModelMeetingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getMeetingByTitle(
      title: $title
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        meetingType {
          meetingType
        }
        title
        date
        shortId
        teamId
        meta
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getMeetingByShortId = /* GraphQL */ `
  query GetMeetingByShortId(
    $shortId: String
    $sortDirection: ModelSortDirection
    $filter: ModelMeetingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getMeetingByShortId(
      shortId: $shortId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        meetingType {
          meetingType
        }
        title
        date
        createdBy
        shortId
        teamId
        meta
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getMeetingsByTeamId = /* GraphQL */ `
  query GetMeetingsByTeamId(
    $teamId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelMeetingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getMeetingsByTeamId(
      teamId: $teamId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        meetingType {
          meetingType
        }
        title
        date
        shortId
        createdBy
        teamId
        meta
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getMeetingsByUserId = /* GraphQL */ `
  query GetMeetingsByUserId(
    $createdBy: ID
    $sortDirection: ModelSortDirection
    $filter: ModelMeetingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getMeetingsByUserId(
      createdBy: $createdBy
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        meetingType {
          meetingType
        }
        title
        date
        shortId
        teamId
        meta
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getSettings = /* GraphQL */ `
  query GetSettings($id: ID!) {
    getSettings(id: $id) {
      id
      key
      val
      isActive
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listSettingss = /* GraphQL */ `
  query ListSettingss(
    $filter: ModelSettingsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSettingss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        key
        val
        isActive
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getSettingsByKey = /* GraphQL */ `
  query GetSettingsByKey(
    $key: String
    $sortDirection: ModelSortDirection
    $filter: ModelSettingsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getSettingsByKey(
      key: $key
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        key
        val
        isActive
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
